import React from "react";
import { Cpu, Factory, GraduationCap, ShieldCheck, Rocket } from "lucide-react";
import styles from "../../styles/metaai/MetaAIAboutCircles.module.css";

const defaultItems = [
  {
    id: 1,
    title: "설립 목적",
    text:
      "인공지능을 통해 산업 현장의 복잡한 문제를 해결하고, 데이터·알고리즘 기반의 AI 기술을 개발하며 인재 양성과 기업 연계를 지원합니다.",
    Icon: Cpu,
  },
  {
    id: 2,
    title: "연구·개발",
    text:
      "제조, 헬스케어, 교통, 에너지 분야에서 AI 솔루션을 개발하고, 데이터 관리와 보안 체계로 신뢰성과 확장성을 확보합니다.",
    Icon: Factory,
  },
  {
    id: 3,
    title: "교육·인재",
    text:
      "기업 맞춤형 교육, 산학 협력, 프로젝트 기반 워크숍을 통해 실무 즉시 투입 가능한 인재를 양성하고, 교육-현장-채용의 선순환 생태계를 구축합니다.",
    Icon: GraduationCap,
  },
  {
    id: 4,
    title: "윤리·신뢰",
    text:
      "공정성, 설명 가능한 AI, 개인정보 보호를 초기 단계부터 반영하며, 산·학·연 협업을 통해 테스트베드와 성과를 공유해 신뢰할 수 있는 AI를 만듭니다.",
    Icon: ShieldCheck,
  },
  {
    id: 5,
    title: "비전",
    text:
      "“Artificial Intelligence Beyond Artificial Intelligence”를 비전으로, 산업과 사회가 체감하는 새로운 표준을 제시하며 고객과 함께 성장하는 동반자가 되겠습니다.",
    Icon: Rocket,
  },
];

function CircleCard({ index, title, text, Icon }) {
  return (
    <div className={styles.cardWrap}>
      <div className={styles.ring}>
        <div className={styles.card}>
          <div className={styles.icon} aria-hidden>
            {Icon ? <Icon size={30} /> : <span>💡</span>}
          </div>
          <h3 className={styles.title}>{title}</h3>
          <p className={`${styles.text} ${styles.clamp4}`}>{text}</p>
        </div>
      </div>
    </div>
  );
}

export default function MetaAIAboutCircles({ items = defaultItems }) {
  const top = items.slice(0, 3);
  const bottom = items.slice(3);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2 className={styles.heading}>회사소개</h2>
          <p className={styles.sub}>인공지능 연구·개발·교육·윤리와 비전을 5가지 키워드로 소개합니다.</p>
        </header>

        <div className={styles.row}>
          {top.map((item, i) => (
            <CircleCard
              key={item.id}
              index={i + 1}
              title={item.title}
              text={item.text}
              Icon={item.Icon}
            />
          ))}
        </div>

        <div className={`${styles.row} ${styles.rowBottom}`}>
          {bottom.map((item, i) => (
            <CircleCard
              key={item.id}
              index={i + 4}
              title={item.title}
              text={item.text}
              Icon={item.Icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
}


